import styled from "styled-components";
import { breakpoints, maxBreakpoints } from "../../../../shared-logic/themes/toyotaTheme";
import * as UscCashPrice from "../common/price/UscCashPrice.styles";
import * as ContentStyles from "../styles/atoms/Content.styles";

export const HeaderInfo = styled.div`
    /* Show long texts inside proper on multiple lines */
    & > span {
        display: inline;

        &:not(:nth-last-child(1)) {
            margin-inline-end: var(--spacing-1);
        }
    }
`;

export const CtaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing-3) / 2);
    width: 100%;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        flex-wrap: wrap;
        gap: var(--spacing-2);

        & > button {
            &:not(:only-child) {
                flex-basis: calc(50% - var(--spacing-2));
            }
        }
    }
`;

export const Actions = styled.div`
    margin: var(--spacing-2) 0 0;
    padding: var(--spacing-2) var(--spacing-2) var(--spacing-3);
    background-color: var(--color-primary-white);
    border-top: 1px solid var(--color-grey-4);

    @media screen and (min-width: ${breakpoints.xl}) {
        display: flex;
        flex-direction: column;
        row-gap: var(--spacing-3);
        margin: 0;
        padding: 0;
        background-color: transparent;
        border-top: 0;
    }
`;

export const MobileOnly = styled.div`
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing-3) / 2);
    width: 100%;

    @media screen and (max-width: ${maxBreakpoints.lg}) {
        flex-direction: row;
        flex-wrap: wrap;

        & > button {
            &:not(:only-child) {
                flex-basis: calc(50% - var(--spacing-2));
            }
        }
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        display: none;
    }
`;

export const DesktopOnly = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: var(--spacing-3);
    width: 100%;

    @media screen and (max-width: ${maxBreakpoints.lg}) {
        display: none;
    }
`;

export const Details = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: var(--spacing-3);
    margin-inline: 0;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;
    height: 100%;
    margin-inline: auto;
    padding-block: 16px;

    @media screen and (min-width: ${breakpoints.xl}) {
        flex-direction: row;
        justify-content: center;
        padding-block: 56px;
    }

    @media screen and (min-width: ${breakpoints.xxxl}) {
        margin-inline: 0;
    }

    @media screen and (min-width: ${breakpoints.max}) {
        max-width: 1444px;
        margin-inline: auto;
    }
`;

export const Content = styled(ContentStyles.Content)`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${breakpoints.xl}) {
        flex-direction: row;
    }
`;

export const RetailPriceList = styled.ul`
    margin: 0 0 calc(var(--spacing-3) / 2);
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        padding: calc(var(--spacing-3) / 2) 0;
        border-bottom: 1px solid var(--color-grey-4);
    }

    ${UscCashPrice.Cash} {
        font-size: 1.3rem;
        line-height: 2rem;
    }
`;

export const SecondaryCtas = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    width: 100%;
    margin-top: var(--spacing-7);
`;
